import type { CreateElement, VNode } from 'vue';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import type { PayPalNamespace, FUNDING_SOURCE } from '@paypal/paypal-js';

@Component
export default class CPayPalButton extends Vue {
	@Prop({ type: Function, default: null })
	createOrder: () => Promise<string>;

	@Prop({ type: Function, default: null })
	onApprove: () => Promise<void>;

	@Prop({ type: Function, default: null })
	onError: () => Promise<void>;

	@Prop({ type: Function, required: true })
	generateElementId: (idString: string) => string;

	@Prop()
	payPal: PayPalNamespace;

	@Prop()
	fundingSource: FUNDING_SOURCE;

	@Prop()
	disablePopup: boolean;

	mounted() {
		this.initializeButton();
	}

	onClick() {
		this.$emit('click');
	}

	render(h: CreateElement): VNode {
		let childNodes: VNode[];
		if (this.$scopedSlots && this.$scopedSlots.default) {
			childNodes = this.$scopedSlots.default({});
		}
		else {
			if (this.fundingSource === this.payPal.FUNDING.VENMO) {
				childNodes = [
					h('div', { attrs: { id: this.generateElementId('venmo-button-container') } })
				];
			}
			else {
				childNodes = [
					h('div', { attrs: { id: this.generateElementId('paypal-button-container') } })
				];
			}
		}
		return h('div', {}, childNodes);
	}

	initializeButton() {
		try {
			const buttonOptions = {
				fundingSource: this.fundingSource,
				createOrder: this.createOrder,
				onApprove: this.onApprove,
				onError: this.onError,
				onClick: this.onClick,
				...(this.disablePopup) && {
					onInit: function (data, actions) {
						actions.disable();
					}
				}
			};

			const button = this.payPal.Buttons(buttonOptions);

			if (button.isEligible()) {
				if (this.fundingSource === this.payPal.FUNDING.PAYPAL)
					button.render(this.generateElementId('#paypal-button-container'));
				else if (this.fundingSource === this.payPal.FUNDING.VENMO)
					button.render(this.generateElementId('#venmo-button-container'));
			}
			else {
				console.error('Error rendering button: ' + this.fundingSource + ' is ineligible');
				this.$emit('error-rendering-button');
			}

			this.$emit('ready');
		}
		catch {
			this.$emit('error-rendering-button');
		}
	}
}